import { render, staticRenderFns } from "./stagePage.vue?vue&type=template&id=8505f65a&scoped=true&"
import script from "./stagePage.vue?vue&type=script&lang=js&"
export * from "./stagePage.vue?vue&type=script&lang=js&"
import style0 from "./stagePage.vue?vue&type=style&index=0&id=8505f65a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505f65a",
  null
  
)

export default component.exports